import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const GET_LEGAL_OBSERVATION_CODE_AFP_REQUEST = "GET_LEGAL_OBSERVATION_CODE_AFP_REQUEST";
export const GET_LEGAL_OBSERVATION_CODE_AFP_SUCCESS = "GET_LEGAL_OBSERVATION_CODE_AFP_SUCCESS";
export const GET_LEGAL_OBSERVATION_CODE_AFP_ERROR = "GET_LEGAL_OBSERVATION_CODE_AFP_ERROR";

//* ACTIONS ------------------------------------------------
export const getLegalObservationCodeAFPRequest = (payload = {}, callback) => ({
  type: GET_LEGAL_OBSERVATION_CODE_AFP_REQUEST,
  payload,
  callback,
});

export const getLegalObservationCodeAFPSuccess = (data) => ({
  type: GET_LEGAL_OBSERVATION_CODE_AFP_SUCCESS,
  payload: data,
});

export const getLegalObservationCodeAFPError = (error) => ({
  type: GET_LEGAL_OBSERVATION_CODE_AFP_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const getLegalObservationCodeAFPServiceRequest = async () => {
  const options = await withToken({
    method: Methods.GET,
    headers: { CompanyId: await getUserCompany() },
  });
  return request(`/afp/observation_codes`, options);
};
